import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const DuplicateIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentcolor">
            {/* eslint-disable-next-line max-len */}
            <path d="M6.25 14.1667V2.5H15.4167V14.1667H6.25ZM7.08333 13.3333H14.5833V3.33333H7.08333V13.3333ZM3.75 16.6667V5.51292H4.58333V15.8333H12.4038V16.6667H3.75Z"/>
        </svg>
    </IconWrapper>
));
